import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { CatalogIcon, CATALOG_ICONS } from "@/lib/catalogIcons";

const COLORS = ["#3b82f6", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6", "#06b6d4", "#ec4899", "#64748b"];

export function CategoryDialog({ value, catalogs, pathOf, onClose, onSave }) {
  const [f, setF] = useState(value);
  const isDesc = (id) => { let c = catalogs.find((x) => x.id === id); while (c) { if (c.id === f.id) return true; c = catalogs.find((x) => x.id === c.parent_id); } return false; };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-slate-900 border-slate-800" data-testid="category-dialog">
        <DialogHeader><DialogTitle>{f.id ? "Kategoriyi Düzenle" : "Yeni Kategori"}</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <div><Label>Kategori Adı</Label>
            <Input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className="bg-slate-950/50 border-slate-700" data-testid="category-form-name" autoFocus /></div>
          <div><Label>Üst Kategori</Label>
            <select value={f.parent_id || ""} onChange={(e) => setF({ ...f, parent_id: e.target.value || null })} data-testid="category-form-parent"
                    className="w-full h-10 bg-slate-950/50 border border-slate-700 rounded-md px-3 text-sm">
              <option value="">— Ana kategori —</option>
              {catalogs.filter((c) => !f.id || !isDesc(c.id)).map((c) => <option key={c.id} value={c.id}>{pathOf(c.id)}</option>)}
            </select></div>
          <div><Label>Renk</Label>
            <div className="flex gap-2 mt-1.5">{COLORS.map((c) => (
              <button key={c} type="button" onClick={() => setF({ ...f, color: c })} data-testid={`category-color-${c.slice(1)}`}
                      className={`h-8 w-8 rounded-full transition-transform ${f.color === c ? "ring-2 ring-white scale-110" : ""}`} style={{ background: c }} />
            ))}</div></div>
          <div><Label>Simge</Label>
            <div className="grid grid-cols-8 gap-1.5 mt-1.5 max-h-32 overflow-y-auto">{CATALOG_ICONS.map((ic) => (
              <button key={ic} type="button" onClick={() => setF({ ...f, icon: ic })} data-testid={`category-icon-${ic}`}
                      className={`h-9 rounded-lg flex items-center justify-center border ${f.icon === ic ? "border-blue-500 bg-blue-600/20" : "border-slate-800 hover:border-slate-600"}`}>
                <CatalogIcon name={ic} size={16} />
              </button>
            ))}</div></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} className="border-slate-700">İptal</Button>
          <Button onClick={() => onSave(f)} className="bg-blue-600 hover:bg-blue-500" data-testid="category-form-save">Kaydet</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
